export default __webpack_public_path__ + "static/media/scilife-logo.78fd727b.jpg";